import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {setUserSetting} from '@ibibo/myaccount-reducer';

import * as S from '../ProfileInfo/ProfileInfo.styles';

import IconSelector from '@ibibo/icon-selector';
import InfoEditPop from '../../InfoEditPop/InfoEditPop';

const CompanyInfo = ({userData, sendTrackingDataToSdk}) => {
  const dispatch = useDispatch();

  const [
    {
      company_name,
      secondary_mobile,
      secondary_email,
      company_address,
      city,
      state,
      pincode,
      business_type,
      is_subUser,
      agreement_document,
    },
    setUserInfo,
  ] = useState({
    company_name: userData.company_name ? userData.company_name.value : '',
    secondary_email: userData.secondary_email ? userData.secondary_email.value : '',
    secondary_mobile: userData.secondary_mobile ? userData.secondary_mobile.value : '',
    company_address: userData.company_address ? userData.company_address.value : '',
    city: userData.city ? userData.city.value : '',
    state: userData.state ? userData.state.value : '',
    pincode: userData.pincode ? userData.pincode.value : '',
    business_type: userData.business_type ? userData.business_type.value : '',
    is_subUser: userData?.is_sub_user ? userData?.is_sub_user : false,
    agreement_document: userData?.agreement_document ? userData?.agreement_document : '',
  });

  useEffect(() => {
    setUserInfo({
      company_name: userData.company_name ? userData.company_name.value : company_name,
      secondary_email: userData.secondary_email ? userData.secondary_email.value : secondary_email,
      secondary_mobile: userData.secondary_mobile
        ? userData.secondary_mobile.value
        : secondary_mobile,
      company_address: userData.company_address ? userData.company_address.value : company_address,
      city: userData.city ? userData.city.value : city,
      state: userData.state ? userData.state.value : state,
      pincode: userData.pincode ? userData.pincode.value : pincode,
      business_type: userData.business_type ? userData.business_type.value : business_type,
      is_subUser: userData?.is_sub_user ? userData?.is_sub_user : false,
      agreement_document: userData?.agreement_document ? userData?.agreement_document : '',
    });
  }, [userData]);

  const [isPopVisible, setPopVisible] = useState(false);

  const showEditPop = () => {
    setPopVisible(true);
  };

  const closePop = () => {
    setPopVisible(false);
  };

  const successCallback = response => {
    // setUserInfo(response);
  };

  const errorCallback = () => {
    // setUserInfo(false);
  };

  const updateUserData = data => {
    setPopVisible(false);
    dispatch(setUserSetting(data, successCallback, errorCallback));
  };

  const downloadAgreement = url => {
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Agreement Download clicked',
        },
      },
      'PROFILE',
    );
    window.open(url, '_blank');
  };

  return (
    <S.ProfileMainWrap>
      <S.ProfileInnerWrap>
        <S.ProfileHeadOuterWrap>
          <S.ProfileHeadInnerWrap>
            <S.HeadMainText>Company Details</S.HeadMainText>
            <S.HeadSubText>Manage company address and other details</S.HeadSubText>
          </S.ProfileHeadInnerWrap>
          {!is_subUser && (
            <S.HeaderEditTag onClick={showEditPop}>
              <IconSelector iconKey="edit" />
              <S.EditText>Edit</S.EditText>
            </S.HeaderEditTag>
          )}
        </S.ProfileHeadOuterWrap>
        <S.ProfileInfoOuterWrap>
          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>company name</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {company_name ? (
                <S.InfoText>{company_name}</S.InfoText>
              ) : (
                !is_subUser && <S.AddInfoText onClick={showEditPop}>{'+Add'}</S.AddInfoText>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>business type</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {business_type ? (
                <S.InfoText>{business_type}</S.InfoText>
              ) : (
                !is_subUser && <S.AddInfoText onClick={showEditPop}>{'+Add'}</S.AddInfoText>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>Company address</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {company_address ? (
                <S.InfoText>{company_address}</S.InfoText>
              ) : (
                !is_subUser && <S.AddInfoText onClick={showEditPop}>+Add</S.AddInfoText>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>City</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {city ? (
                <S.InfoText>{city}</S.InfoText>
              ) : (
                !is_subUser && <S.AddInfoText onClick={showEditPop}>+Add</S.AddInfoText>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>State</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {state ? (
                <S.InfoText>{state}</S.InfoText>
              ) : (
                !is_subUser && <S.AddInfoText onClick={showEditPop}>+Add</S.AddInfoText>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>Pin code</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {pincode ? (
                <S.InfoText>{pincode}</S.InfoText>
              ) : (
                !is_subUser && <S.AddInfoText onClick={showEditPop}>+Add</S.AddInfoText>
              )}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>

          {/* <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
                <S.TitleText>Secondary E-mail Id</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {secondary_email ? <S.InfoText>{secondary_email}</S.InfoText> : <S.AddInfoText onClick={showEditPop}>+Add</S.AddInfoText>}
              {/* <S.VerifiedTag>
                  <IconSelector iconKey="edit" />
                  <S.DeleteIconWrap>
                      <IconSelector iconKey="delete" props={{margin: '0 0 0 1.5rem'}}/>
                      <S.DeleteToolTip>
                          <S.ConfirmText>Are you sure you want to remove this email ID?</S.ConfirmText>
                          <S.UserOtionWrap>
                              <S.CancelLink>Cancel</S.CancelLink>
                              <S.ConfirmLink>Yes, remove</S.ConfirmLink>
                          </S.UserOtionWrap>
                      </S.DeleteToolTip>
                  </S.DeleteIconWrap>
              </S.VerifiedTag> 
          </S.InfoTextWrap>
        </S.ProfileInfoInnerWrap> */}

          <S.ProfileInfoInnerWrap>
            <S.InfoTitleWrap>
              <S.TitleText>Secondary Mobile Number</S.TitleText>
            </S.InfoTitleWrap>
            <S.InfoTextWrap>
              {secondary_mobile ? (
                <S.InfoText>{secondary_mobile}</S.InfoText>
              ) : (
                !is_subUser && <S.AddInfoText onClick={showEditPop}>+Add</S.AddInfoText>
              )}
              {/* <S.VerifiedTag>
                    <IconSelector iconKey="edit" />
                    <S.DeleteIconWrap>
                        <IconSelector iconKey="delete" props={{margin: '0 0 0 1.5rem'}}/>
                        <S.DeleteToolTip>
                            <S.ConfirmText>Are you sure you want to remove this email ID?</S.ConfirmText>
                            <S.UserOtionWrap>
                                <S.CancelLink>Cancel</S.CancelLink>
                                <S.ConfirmLink>Yes, remove</S.ConfirmLink>
                            </S.UserOtionWrap>
                        </S.DeleteToolTip>
                    </S.DeleteIconWrap>
                </S.VerifiedTag> */}
            </S.InfoTextWrap>
          </S.ProfileInfoInnerWrap>
          {!is_subUser && agreement_document?.show && (
            <S.ProfileInfoInnerWrap>
              <S.InfoTitleWrap>
                <S.TitleText>myPartner Agreement</S.TitleText>
              </S.InfoTitleWrap>
              <S.InfoTextWrap>
                {
                  <S.DownloadAgreement onClick={() => downloadAgreement(agreement_document?.value)}>
                    Download
                  </S.DownloadAgreement>
                }
              </S.InfoTextWrap>
            </S.ProfileInfoInnerWrap>
          )}
        </S.ProfileInfoOuterWrap>
      </S.ProfileInnerWrap>

      {isPopVisible ? (
        <InfoEditPop closePop={closePop} userData={userData} newUserData={updateUserData} />
      ) : null}
    </S.ProfileMainWrap>
  );
};

export default CompanyInfo;
